/* eslint-disable */
import { SET_USER_FIELDS }  from "../../constants";

const initialState = {
    fields_person: [],
    fields_entity: [],
    fields_structure: [],
    structures_type: [],
};

const workReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_FIELDS: {
            const data = action.payload || {};
            return {
                ...state,
                // Normalizar posibles nombres de campos que vengan desde el API
                fields_person: data.fields_person || data.fieldsPerson || [],
                fields_entity: data.fields_entity || data.fieldsEntity || [],
                // API actual devuelve `fields_structures` (plural) según consola
                fields_structure:
                    data.fields_structures || data.fields_structure || data.fields_estructure || [],
                // API actual devuelve `structure_types` (plural)
                structures_type:
                    data.structure_types || data.structure_type || data.structures_type || [],
            };
        }
        default:
            return state;
    };
}
export default workReducer;